// extracted by mini-css-extract-plugin
export default {"changeLink":"MO-z","disabled":"NO-z","inline":"OO-z"};